import React from "react";

import { Allotment } from "allotment";
import "allotment/dist/style.css";

import { ContractorsGrid } from "@app/components/contractors/contractorsGrid";
import { ContractorEditingGroup } from "@app/components/contractors/formGroupClient";
import { useWindowDimensions } from "@app/contexts";

import "./contractorsmain.scss";

export const ContractorsMain = () => {
  const {
    height: fullHeight,
    headersFooters,
    width,
    rightReserved,
  } = useWindowDimensions();
  const oneQuarter = (width - rightReserved) / 4;
  // const oneThird = (width - rightReserved) / 3;
  return (
    <div
      id={"contractors-page"}
      style={{
        height: `${fullHeight - headersFooters}px`,
        width: `${width - rightReserved}px`,
      }}
    >
      <Allotment snap>
        <Allotment.Pane
          key={"grid"}
          minSize={oneQuarter}
          prefferedSize={oneQuarter}
          snap={false}
        >
          <ContractorsGrid />
        </Allotment.Pane>
        <Allotment.Pane
          key={"forms"}
          minSize={Math.max(500, oneQuarter)}
          snap={false}
        >
          <div
            style={{
              height: "100%",
              padding: "2px",
            }}
          >
            {/* <div id="mspv-command">
              <div>ToolbarTop</div>
            </div> */}
            <ContractorEditingGroup />
          </div>
        </Allotment.Pane>
      </Allotment>
    </div>
  );
};
